import { useMemo } from 'react';
import { useAppSelector } from 'src/store/hooks';

export const useAddonFeatures = () => {
  const shopifyVariants = useAppSelector(state => state.signUp.shopifyVariants);

  return useMemo(() => {
    const baseFeatures = [
      'Support your results with supplements designed to fuel and accelerate your progress',
    ];

    if (!shopifyVariants || shopifyVariants.length === 0) {
      // Explicit deny: if no variants available, don't show any supplements
      return baseFeatures;
    }

    const hasProteinFlavour = shopifyVariants.some(
      variant => variant.is_protein_flavour === 1
    );
    if (hasProteinFlavour) {
      baseFeatures.push(
        '1 x Whey Protein Powder 500g (Flavour of your choice)'
      );
    }

    const hasCollagen = shopifyVariants.some(
      variant =>
        variant.variant_name?.toLowerCase().includes('collagen') &&
        variant.is_included === 1
    );
    if (hasCollagen) {
      baseFeatures.push('1 x Collagen Hot Chocolate 240g');
    }

    const hasShaker = shopifyVariants.some(
      variant =>
        variant.variant_name?.toLowerCase().includes('shaker') &&
        variant.is_included === 1
    );
    if (hasShaker) {
      baseFeatures.push('1 x shaker 600ml');
    }

    baseFeatures.push('Free postage Australia-wide');

    return baseFeatures;
  }, [shopifyVariants]);
};
